module.exports = __webpack_public_path__ + "static/media/cooling1.b2eb0d10.jpg";